module.exports = __webpack_public_path__ + "04_bob_gold.37ddd066.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer5/04_bob_gold.png
// module id = avlK
// module chunks = 0